import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Box,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import {
    AccountCircle as AccountIcon,
    Home as HomeIcon,
    Quiz as ProblemsIcon,
    Source as SourceIcon,
    AccountTree as TopicsIcon,
    Psychology as TechniqueIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
    const { user, signOut } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSignOut = async () => {
        await signOut();
        handleClose();
        navigate('/auth');
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8
                        }
                    }}
                    onClick={() => navigate('/')}
                >
                    Sapo Math Database
                </Typography>

                {user && (
                    <Box sx={{ display: 'flex', gap: 1, mr: 2 }}>
                        <Button
                            color="inherit"
                            startIcon={<HomeIcon />}
                            onClick={() => navigate('/')}
                        >
                            Home
                        </Button>
                        <Button
                            color="inherit"
                            startIcon={<ProblemsIcon />}
                            onClick={() => navigate('/')}
                        >
                            Problems
                        </Button>
                        <Button
                            color="inherit"
                            startIcon={<SourceIcon />}
                            onClick={() => navigate('/sources')}
                        >
                            Sources
                        </Button>
                        <Button
                            color="inherit"
                            startIcon={<TopicsIcon />}
                            onClick={() => navigate('/curriculum-topics')}
                        >
                            Topics
                        </Button>
                        <Button
                            color="inherit"
                            startIcon={<TechniqueIcon />}
                            onClick={() => navigate('/techniques')}
                        >
                            Techniques
                        </Button>
                    </Box>
                )}

                {user && (
                    <div>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem disabled>{user.email}</MenuItem>
                            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                        </Menu>
                    </div>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navigation;
